// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SignRecycleIconSignature {
  Element: SVGSVGElement;
}

export const SignRecycleIcon: TOC<SignRecycleIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.03998L14.083 9.74398L12.295 10.827L16.932 12.697L17.429 7.71798L15.795 8.70698L12.872 3.50998C12.518 2.87998 11.483 2.87998 11.129 3.50998L7.716 9.57698L9.459 10.557L12 6.03998ZM21.872 19.51L18.488 13.494L16.745 14.474L19.29 19H16V17L12 20L16 23V21H21C21.355 21 21.684 20.812 21.863 20.505C22.042 20.199 22.046 19.819 21.872 19.51ZM8.31299 16.666L6.53699 15.754L4.71 19H11V21H3C2.645 21 2.316 20.812 2.136 20.505C1.957 20.199 1.954 19.82 2.128 19.51L4.756 14.839L2.976 13.924L7.475 11.738L8.31299 16.666Z"/>
</svg>
</template>;